import { useUtils } from "@/app/hooks/useUtils";
import { CheckIcon } from "lucide-react";

interface ViewCommentModalState {
  appointmentNotes: string;
  source?: string;
}

const CommentViewComponent: React.FC<ViewCommentModalState> = (props) => {
  const { convertNoteToArray } = useUtils();

  // Function to split text into chunks of 30 characters
  const splitIntoChunks = (str: string, chunkSize: number) => {
    const chunks = [];
    for (let i = 0; i < str.length; i += chunkSize) {
      chunks.push(str.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const flag = props?.appointmentNotes?.startsWith("<ol>");
  const flage_li = props?.appointmentNotes?.startsWith("<li><b>");

  const viewComment = () => {
    const cleanedArray = props?.appointmentNotes
      .replace(/<li><b>/g, "")
      .replace(/<\/b><\/li>/g, "")
      .replace(/<\/ol>/g, "")
      .trim()
      .split(/\n|<br\s*\/?>|,/g) // optional splitting if multiple items
      .map((item) => item.trim()) // clean up extra spaces
      .filter((item) => item !== "");
    return cleanedArray;
  };

  const notes = flage_li
    ? viewComment()
    : flag
      ? convertNoteToArray(props?.appointmentNotes)
      : props?.appointmentNotes?.split("||");
  const commentData = notes?.filter((item) => item?.trim() !== "")?.filter((item) => item !== "Other:");

  return (
    <div>
      <ol type="1" className="w-full">
        {commentData?.map((com: string, idx) => {
          // Break the comment into chunks of 30 characters
          const chunks = splitIntoChunks(com, 40);

          return (
            <li
              key={`${com}:${idx}`}
              className="flex flex-col w-full whitespace-nowrap break-words items-left justify-start "
            >
              {props.source === "PWL" ? (
                <span className="flex items-center gap-1 text-xs">
                  <CheckIcon className="w-3 h-3" />
                  {com}
                </span>
              ) : (
                chunks.map((chunk, chunkIdx) => (
                  <p key={chunkIdx} className="text-xs text-black font-semibold  ">
                    {chunk}
                  </p>
                ))
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
};
export default CommentViewComponent;
